const discountForms = document.querySelectorAll<HTMLElement>('.f-discount');
discountForms.forEach(form => {
  const input = form.querySelector<HTMLInputElement>('.f-discount__input input');
  const link = form.querySelector<HTMLElement>('.f-discount__open-link');

  if(!input) return;

  if(input.value) form.classList.add('--open');

  link?.addEventListener('click', (e) => {
    e.preventDefault();

    form.classList.add('--open');
  })
})
